import { api } from '@/config/api';

export interface AvailableAdAccount {
  id: string;
  name: string;
  currency: string;
  status: number;
  timezone: string;
}

export interface ConnectedAdAccount {
  accountUid: string;
  companyUid: string;
  adAccountId: string;
  adAccountName: string;
  currency: string;
  isDefault: boolean;
  isActive: boolean;
  tokenExpiresAt?: string;
  oauthGrantedAt?: string;
}

/**
 * Client for the "Connect with Meta" OAuth flow on the backend.
 * Pairs with `<ConnectMetaButton />` which drives the popup + postMessage choreography.
 */
export const metaOAuthService = {
  start: async (): Promise<{ url: string }> =>
    (await api.get('/slighter_crm/facebook/oauth/start', { withCredentials: true })).data,

  finalize: async (body: { oauthSessionId: string; adAccountId: string }) =>
    (await api.post('/slighter_crm/facebook/oauth/finalize', body)).data as {
      ok: true;
      adAccount: ConnectedAdAccount;
    },

  disconnect: async () =>
    (await api.post('/slighter_crm/facebook/oauth/disconnect')).data as { ok: true },
};
